import { Menu, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";

import { useNavigate } from "../../hooks/useNavigate";
import { ButtonPrimaryStyle } from "../ButtonPrimary";
import "./filefeedImporter.css";

const FilefeedImporterTrigger = () => {
  const navigate = useNavigate();
  const [Importer, setImporter] = useState(null);
  const [importKey, setImportKey] = useState(0);

  const handleBulkOpen = async () => {
    if (!Importer) {
      const { default: FilefeedImporter } = await import("./FilefeedImporter");
      setImporter(() => FilefeedImporter);
    }
    setImportKey((key) => key + 1);
  };

  return (
    <>
      <Menu as="div" className="filefeed-invite-menu">
        {({ open }) => (
          <>
            <Menu.Button
              className={ButtonPrimaryStyle}
              aria-label="Request insurance data"
            >
              Request insurance data
              <svg
                viewBox="0 0 16 16"
                className={`filefeed-invite-menu__chevron-icon${
                  open ? " filefeed-invite-menu__chevron-icon--open" : ""
                }`}
                aria-hidden="true"
              >
                <path d="M3.2 5.6 8 10.4l4.8-4.8L14 6.8 8 12.8 2 6.8l1.2-1.2Z" />
              </svg>
            </Menu.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="filefeed-invite-menu__items">
                <Menu.Item>
                  {({ active }) => (
                    <button
                      type="button"
                      onClick={() => navigate("/ignition/new")}
                      className={`filefeed-invite-menu__item${
                        active ? " filefeed-invite-menu__item--active" : ""
                      }`}
                    >
                      Single request
                    </button>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      type="button"
                      onClick={handleBulkOpen}
                      className={`filefeed-invite-menu__item${
                        active ? " filefeed-invite-menu__item--active" : ""
                      }`}
                    >
                      Multiple requests (via CSV)
                    </button>
                  )}
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </>
        )}
      </Menu>
      {Importer && importKey > 0 ? (
        <Importer key={importKey} openOnMount hideTrigger />
      ) : null}
    </>
  );
};

export default FilefeedImporterTrigger;
